import React, { useEffect, useState } from 'react';
import CarHops from './CarHops'
import Delivery from './Delivery'
import DinIn from './DinIn'
import PickUp from './PickUp'


export default function OrderOptions(props: any) {
  return (
    <div className='order-options'>
      {process.env.REACT_APP_DELIVERY_ENABLE == "true" && <Delivery />}
      <PickUp />
    </div>
  )
}
